import { render, staticRenderFns } from "./Disaster.vue?vue&type=template&id=479a6976&scoped=true&"
import script from "./Disaster.vue?vue&type=script&lang=js&"
export * from "./Disaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479a6976",
  null
  
)

export default component.exports